"use strict";

angular.module("licensure.services").factory("EXSessionExaminers", [
    "$http",
    "$q",
    function ($http, $q) {
        return {
            getbysession: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamSessions/" + id + "/Examiners", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        };
    }
]);
